const STORAGE_KEY = "geolocation";

function safeParseJSON(rawValue) {
  if (!rawValue) return null;

  try {
    return JSON.parse(rawValue);
  } catch {
    return null;
  }
}

function normalizeGeolocation(value = {}) {
  const lat = Number(value?.lat ?? value?.latitude ?? value?.latitud);
  const lng = Number(value?.lng ?? value?.longitude ?? value?.longitud);

  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

  return {
    lat: lat.toString(),
    lng: lng.toString(),
    timestamp: value?.timestamp || new Date().toISOString(),
    device: value?.device || "",
    accuracy: value?.accuracy ?? null,
    source: value?.source || "unknown",
    updatedBy: value?.updatedBy || null,
  };
}

export function getStoredGeolocation() {
  if (typeof window === "undefined") return null;

  const parsed = safeParseJSON(window.localStorage.getItem(STORAGE_KEY));
  return normalizeGeolocation(parsed);
}

export function hasStoredGeolocation() {
  return Boolean(getStoredGeolocation());
}

export function setStoredGeolocation(value) {
  if (typeof window === "undefined") return null;

  const normalized = normalizeGeolocation(value);
  if (!normalized) return null;

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
  return normalized;
}

export function clearStoredGeolocation() {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(STORAGE_KEY);
}

